import { AfterViewInit, Component } from '@angular/core';
import { NavController, NavParams, ToastController, PopoverController, Events, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";

@Component({
  selector: 'notices',
  templateUrl: 'notices.html',
  inputs: ['noticeData', 'noticePlaceholder']
})
export class NoticesPage implements AfterViewInit {

  noticeEnabled = false;
  noticeData: any;
  noticeDataProcessed: any = [];
  noticePlaceholder: string;
  placeholder: string = "Notiz erstellen...";
  addNoticeURL: string;
  addNoticeParams: string;
  addNoticeWithFileURL: string;
  addNoticeWithFileParams: string;
  addNoticeTypes: any;
  inputMessage: any;
  base64File: any = "";
  base64FileName: any = "";
  base64FileType: any = "";
  colorDesign: string = "";

  selectOptions: any;

  isSending: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    private toastCtrl: ToastController,
    private ebsWebServiceGlobals: EbsWebServiceGlobals,
    private _ebsWebService: EbsWebService,
    public popoverCtrl: PopoverController,
    public events: Events,
    private alertCtrl: AlertController) {
    this.events.subscribe('notices:filepicker', (base64, filename, filetype) => {
      this.base64File = base64;
      this.base64FileName = filename;
      this.base64FileType = filetype;
    });

    this.selectOptions = {
      title: 'Notiztyp',
      //subTitle: 'Wählen sie einen Notiztyp aus',
      mode: 'md'
    };
  }

  ngAfterViewInit(): void {
    this.inputMessage = "";
    this.colorDesign = this.ebsWebServiceGlobals.getColorDesign();

    if (typeof this.noticeData.ListItemAction != "undefined") {
      this.getNoticeActionURLsFromWebServiceData(this.noticeData.ListItemAction);
    }

    if (typeof this.noticePlaceholder != "undefined" && this.noticePlaceholder != "") {
      this.placeholder = this.noticePlaceholder;
    }

    if (typeof this.noticeData.ListItemContent != "undefined") {
      this.buildNoticeObjectsFromWebServiceData(this.noticeData.ListItemContent);
    }

  }


  getNoticeActionURLsFromWebServiceData(webServiceData) {
    if (webServiceData == null) {
      return;
    }

    webServiceData.forEach(element => {
      switch (element.ActionName) {
        case "AddNotice":
          this.addNoticeURL = element.ActionUrl;
          this.addNoticeParams = element.PostParameters;
          if (element.Dynamic != null && element.Dynamic.NoticeTypes != null) {
            this.addNoticeTypes = { 'selected': undefined, 'elements': element.Dynamic.NoticeTypes.split(';') || [''] };
          }
          break;
        case "AddNoticeWithFile":
          this.addNoticeWithFileURL = element.ActionUrl;
          this.addNoticeWithFileParams = element.PostParameters;
          if (element.Dynamic != null && element.Dynamic.NoticeTypes != null) {
            this.addNoticeTypes = { 'selected': undefined, 'elements': element.Dynamic.NoticeTypes.split(';') || [''] };
          }
          break;
        default:
      }
    });
  }

  buildNoticeObjectsFromWebServiceData(webServiceData) {
    if (webServiceData == null) {
      return;
    }

    console.log(webServiceData);

    webServiceData.forEach(element => {
      let noticeObject = { title: "", type: "", subtitleShort: "", subtitleFull: "", date: "", icon: "", element: "", filename: "", filedata: "", filetype: "", downloadAction: "", downloadParams: "", downloadIcon: "", downloadViewType: "", deleteAction: "", deleteParams: "", deleteIcon: "", isMultinotice: false, multiFiles: [] };
      if (typeof element.ListItemContent != "undefined") {
        element.ListItemContent.forEach(childElement => {
          switch (childElement.TemplateIdentifier) {
            case "Title":
              noticeObject.title = childElement.DisplayText;
              break;
            case "Subtitle":
              noticeObject.type = childElement.GroupDisplayName;
              if (childElement.DisplayText.endsWith('...')) {
                noticeObject.subtitleShort = childElement.DisplayText;
                noticeObject.subtitleFull = childElement.EditValue;
              } else {
                noticeObject.subtitleShort = childElement.EditValue;
                noticeObject.subtitleFull = childElement.EditValue;
              }
              //console.log(childElement.DisplayText.replace(noticeObject.type, '').trim());
              //if (noticeObject.type != null && noticeObject.type.trim() != childElement.DisplayText.trim()) {
              //  noticeObject.subtitleShort = childElement.DisplayText.replace(noticeObject.type, '').trim();
              //} else {
              //  noticeObject.subtitleShort = childElement.DisplayText.trim();
              //}
              //noticeObject.subtitleFull = childElement.EditValue.trim();
              //if (noticeObject.subtitleFull == '-') {
              //  noticeObject.subtitleFull = noticeObject.subtitleShort;
              //}
              //if (noticeObject.subtitleShort.length == 0) {
              //  noticeObject.subtitleShort = noticeObject.subtitleFull;
              //}
              break;
            case "Date":
              noticeObject.date = childElement.DisplayText;
              break;
            case "Icon":
              if (childElement.ViewTypeAction == "DownloadFile" || childElement.ViewTypeAction == "Popup") {
                noticeObject.downloadAction = childElement.Action;
                noticeObject.downloadParams = childElement.PostParameters;
                noticeObject.downloadIcon = childElement.LabelCaption;
                noticeObject.downloadViewType = childElement.ViewTypeAction;
                noticeObject.element = childElement;
              } else {
                noticeObject.icon = childElement.LabelCaption;
              }
              break;
            default:
          }
        });

        if (element.ListItemAction != undefined) {
          element.ListItemAction.forEach(childElement => {
            switch (childElement.ActionName) {
              case "DeleteNotice":
                noticeObject.deleteIcon = childElement.Icon;
                noticeObject.deleteAction = childElement.ActionUrl;
                noticeObject.deleteParams = childElement.PostParameters;
                noticeObject.element = childElement;
                break;
              default:
            }
          });
        }

        if (this.base64FileName != "" && this.base64File == "") {
          noticeObject.filename = this.base64FileName;
          noticeObject.filedata = this.base64File;
          noticeObject.filetype = this.base64FileType;
        }
        this.noticeDataProcessed.push(noticeObject);
      }
    })

    this.groupNotices();
  }

  groupNotices() {
    let alreadyGrouped = [];
    for (let i = 0; i < this.noticeDataProcessed.length; i++) {
      let notice = this.noticeDataProcessed[i];
      if (alreadyGrouped.indexOf(notice.subtitleFull) === -1) {
        let same = this.noticeDataProcessed.filter(n => n.subtitleFull == notice.subtitleFull);
        if (same.length > 1) {
          alreadyGrouped.push(notice.subtitleFull);
          notice.isMultinotice = true;
          for (let j = 0; j < same.length; j++) {
            if (same[j].downloadIcon.length > 0 && same[j].downloadAction.length > 0 && same[j].downloadParams.length > 0) {
              notice.multiFiles.push({ downloadIcon: same[j].downloadIcon, downloadAction: same[j].downloadAction, downloadParams: same[j].downloadParams, downloadViewType: same[j].downloadViewType });
            }
          }
        }
      }
    }

    for (let i = 0; i < alreadyGrouped.length; i++) {
      this.noticeDataProcessed = this.noticeDataProcessed.filter(x => (x.subtitleFull == alreadyGrouped[i] && x.isMultinotice == true) || (x.subtitleFull != alreadyGrouped[i]))
    }
  }

  sendButton() {
    if (this.base64File != null && this.base64File.length != 0) {
      if (typeof (this.base64File) == 'string') {
        this.addNoticeWithFile(this.base64File, this.base64FileType, this.base64FileName, this.buildMessage());
      } else {
        this.addNoticeWithMultifile(this.base64File[0], this.base64FileType[0], this.base64FileName[0], 0);
      }
    } else {
      this.addNotice();
    }
  }

  addNoticeWithMultifile(base64, filetype, filename, index) { // recursive
    let message = this.buildMessage();
    let postPayloadObject = this.buildNoticeWithFilePayload(base64, filetype, filename, message);
    this._ebsWebService.postData(this.addNoticeWithFileURL, postPayloadObject).subscribe(res => {
      //this.addObject(res);
      if (index + 1 < this.base64File.length) {
        index++;
        this.addNoticeWithMultifile(this.base64File[index], this.base64FileType[index], this.base64FileName[index], index);
      } else {
        this.events.publish("detail:reloadPageWithResponse", res);
      }

    });
  }

  addNoticeWithFile(base64, filetype, filename, message) {
    let postPayloadObject = this.buildNoticeWithFilePayload(base64, filetype, filename, message);
    this._ebsWebService.postData(this.addNoticeWithFileURL, postPayloadObject).subscribe(res => {
      //this.addObject(res);
      this.events.publish("detail:reloadPageWithResponse", res);
    });
  }

  addNotice() {
    if (this.inputMessage != null || this.inputMessage != "") {
      let params = this.addNoticeParams.replace("MESSAGE", this.buildMessage());
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
      this._ebsWebService.postData(this.addNoticeURL, postPayloadObject).subscribe(res => {
        //this.addObject(res);
        this.events.publish("detail:reloadPageWithResponse", res);
      });
    } else {
      console.log("Message leer!");
    }
  }

  buildMessage() {
    let msg = this.inputMessage;
    if (this.addNoticeTypes.selected != undefined) {
      msg += '[NOTICETYPE:' + this.addNoticeTypes.selected + ']';
    }
    return msg;
  }

  buildNoticeWithFilePayload(base64, filetype, filename, message) {
    filetype = filetype.replace("image/jpeg", "jpg");
    filetype = filetype.replace("application/vnd.openxmlformats-officedocument.wordprocessingml.document", "docx");
    filetype = filetype.replace("application/pdf", "pdf");
    filetype = filetype.replace("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xlsx");
    filetype = filetype.replace("image/png", "png");
    filetype = filetype.replace("application/vnd.ms-powerpoint", "ptt");

    base64 = encodeURIComponent(base64.split(',')[1]);

    let params = this.addNoticeWithFileParams.replace("MESSAGE", message);
    params = params.replace("FILEBYTES", base64);
    params = params.replace("FILETYPE", filetype)
    params = params.replace("FILENAME", filename)
    params = params.replace("&path=", "");

    return this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
  }

  addObject(res) {
    let toast = this.toastCtrl.create({
      message: res.Caption,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();

    this.buildNoticeObjectsFromWebServiceData(res.ListItemContent);
  }

  removeNotice(deleteURL, deleteParams, element) {
    let alert = this.alertCtrl.create({
      title: 'Löschen',
      message: 'Möchten sie die Notiz löschen?',
      buttons: [
        {
          text: 'Nein',
          role: 'cancel',
          handler: () => {
            let toast = this.toastCtrl.create({
              message: 'Notiz wurde nicht gelöscht',
              duration: 5000,
              position: 'bottom'
            });
            toast.present();
          }
        },
        {
          text: 'Ja',
          handler: () => {
            let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(deleteParams);
            this._ebsWebService.postData(deleteURL, postPayloadObject).subscribe(res => {
              let toast = this.toastCtrl.create({
                message: res.Caption,
                duration: 5000,
                position: 'bottom'
              });
              toast.present();
              if (!res.Caption.includes('failed')) {
                //var index = this.noticeDataProcessed.indexOf(element);
                //if (index !== -1) {
                //  this.noticeDataProcessed.splice(index, 1);
                //}
                this.events.publish("detail:reloadPageWithResponse", res);
              }
            });
          }
        }
      ]
    });
    alert.present();
  }

  toggleNoticeText(notice) {
    let tempSubtitle = notice.subtitleFull;
    notice.subtitleFull = notice.subtitleShort;
    notice.subtitleShort = tempSubtitle;
  }

  viewImage() {

  }

}



// WEBPACK FOOTER //
// ./src/components/notices/notices.ts